import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/shared/StatusBadge";

// Idempotent Xero invoice export for one RECORDED charge. Shows the truthful export state; never takes payment.
export function XeroExportButton({ entryId, export: exp, onChanged }) {
  const run = async () => {
    try {
      const { data } = await api.post(`/payments/${entryId}/xero-export`);
      if (data.status === "EXPORTED") toast.success(`Exported to Xero as ${data.xero_invoice_number || data.xero_invoice_id}`);
      else toast.warning(data.last_error || data.status);
      onChanged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Export failed"); }
  };
  if (exp?.status === "EXPORTED") return <span data-testid={`xero-exported-${entryId}`} className="text-xs text-jigsaw-success">Xero {exp.xero_invoice_number || "invoice"}</span>;
  return (
    <div className="flex items-center gap-2">
      {exp && <StatusBadge status={exp.status} />}
      <Button data-testid={`xero-export-${entryId}`} size="sm" variant="outline" onClick={run} title={exp?.last_error || ""}>{exp ? "Retry Xero export" : "Export to Xero"}</Button>
    </div>
  );
}
